import { useMutation } from '@tanstack/react-query';
import { axios } from '@repo/http';
export function useResendVerificationEmail() {
    return useMutation({
        mutationFn: ()=>axios.post('/v2/user/resend-verification-email')
    });
}
